export default function Research() {
    
    return (
        <div>

        </div>
    );
}
